<template lang="pug">
  ods-dropdown(
    :hide-on-click='false'
    icon='setting'
    @visible-change='handleVisibleChange')
    ods-dropdown-menu.popover-columns.desplegable(slot='dropdown')
      h3.titulosetting {{ $t('msg_generics.filter_table_menu') }}
      ods-dropdown-item(
        v-for='(column, index) in columns',
        :key='index')
        ods-checkbox(
          @input='handlerShowColumns(column)',
          v-model='column.show')
          | {{ column.text }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'b2b-table-menu-facturas',
  props: [],
  data () {
    return {
      columns: [],
      column: {}
    }
  },
  computed: {
    ...mapGetters([
      'isShowCompradorFactura',
      'isShowNumeroFactura',
      'isShowEmisionFactura',
      'isShowFechaRegistroFactura',
      'isShowClaseFactura',
      'isShowImporteFactura',
      'isShowEstadoFactura',
      'isShowEnvioFactura',
      'isShowVendedorFactura',
      'isShowDivisaFactura',
      'isShowNumRegistroFactura',
      'isShowNumSerieFactura',
      'isShowCentroVendedorFactura',
      'isShowCentroGenericCompradorFactura',
      'isShowCentroCompradorFactura',
      'isShowCentroEntregaCompradorFactura',
      'isShowCentroFacturadoCompradorFactura',
      'isShowAnulacionFactura',
      'isShowServicioFactura',
      'isShowTerceroInEmittedSearch',
      'isShowCanalFactura',
      'isShowIdDatabaseFactura',
      'optionsFilterService',
      'isShowAccountingDate',
      'isShowPaymentDate',
      'isShowPaymentMethod',
      'isShowSentInEmittedSearch',
      // Permisos
      'canCancelInvoice',
      'canViewDistributionCentres'
    ])
  },

  methods: {
    ...mapActions([
      'isShowCompradorFacturaAction',
      'isShowNumeroFacturaAction',
      'isShowEmisionFacturaAction',
      'isShowFechaRegistroFacturaAction',
      'isShowClaseFacturaAction',
      'isShowImporteFacturaAction',
      'isShowEstadoFacturaAction',
      'isShowEnvioFacturaAction',
      'isShowVendedorFacturaAction',
      'isShowDivisaFacturaAction',
      'isShowNumRegistroFacturaAction',
      'isShowNumSerieFacturaAction',
      'isShowCentroVendedorFacturaAction',
      'isShowCentroGenericCompradorFacturaAction',
      'isShowCentroCompradorFacturaAction',
      'isShowCentroEntregaCompradorFacturaAction',
      'isShowCentroFacturadoCompradorFacturaAction',
      'isShowAnulacionFacturaAction',
      'isShowServicioFacturaAction',
      'isShowTerceroInEmittedSearchAction',
      'isShowCanalFacturaAction',
      'isShowIdDatabaseFacturaAction',
      'isShowAccountingDateAction',
      'isShowPaymentDateAction',
      'isShowPaymentMethodAction',
      'isShowSentInEmittedSearchAction'
    ]),

    handlerShowColumns (col) {
      console.log('handlerShowColumns en B2bTable: ', col)
      const column = col.value
      let isShow
      switch (column) {
        case 'comprador':
          isShow = !this.isShowCompradorFactura
          this.isShowCompradorFacturaAction(isShow)
          break
        case 'vendedor':
          isShow = !this.isShowVendedorFactura
          this.isShowVendedorFacturaAction(isShow)
          break
        case 'numero':
          isShow = !this.isShowNumeroFactura
          this.isShowNumeroFacturaAction(isShow)
          break
        case 'emision':
          isShow = !this.isShowEmisionFactura
          this.isShowEmisionFacturaAction(isShow)
          break
        case 'fecha-registro':
          isShow = !this.isShowFechaRegistroFactura
          this.isShowFechaRegistroFacturaAction(isShow)
          break
        case 'clase-factura':
          isShow = !this.isShowClaseFactura
          this.isShowClaseFacturaAction(isShow)
          break
        case 'importe':
          isShow = !this.isShowImporteFactura
          this.isShowImporteFacturaAction(isShow)
          break
        case 'estado':
          isShow = !this.isShowEstadoFactura
          this.isShowEstadoFacturaAction(isShow)
          break
        case 'envio':
          isShow = !this.isShowEnvioFactura
          this.isShowEnvioFacturaAction(isShow)
          break
        case 'divisa':
          isShow = !this.isShowDivisaFactura
          this.isShowDivisaFacturaAction(isShow)
          break
        case 'numero-registro':
          isShow = !this.isShowNumRegistroFactura
          this.isShowNumRegistroFacturaAction(isShow)
          break
        case 'numero-serie':
          isShow = !this.isShowNumSerieFactura
          this.isShowNumSerieFacturaAction(isShow)
          break
        case 'centro-vendedor':
          isShow = !this.isShowCentroVendedorFactura
          this.isShowCentroVendedorFacturaAction(isShow)
          break
        case 'centro':
          isShow = !this.isShowCentroGenericCompradorFactura
          this.isShowCentroGenericCompradorFacturaAction(isShow)
          break
        case 'centro-comprador':
          isShow = !this.isShowCentroCompradorFactura
          this.isShowCentroCompradorFacturaAction(isShow)
          break
        case 'centro-entrega':
          isShow = !this.isShowCentroEntregaCompradorFactura
          this.isShowCentroEntregaCompradorFacturaAction(isShow)
          break
        case 'centro-facturado':
          isShow = !this.isShowCentroFacturadoCompradorFactura
          this.isShowCentroFacturadoCompradorFacturaAction(isShow)
          break
        case 'anulacion':
          isShow = !this.isShowAnulacionFactura
          this.isShowAnulacionFacturaAction(isShow)
          break
        case 'servicio':
          isShow = !this.isShowServicioFactura
          this.isShowServicioFacturaAction(isShow)
          break
        case 'tercero':
          isShow = !this.isShowTerceroInEmittedSearch
          this.isShowTerceroInEmittedSearchAction(isShow)
          break
        case 'canal':
          isShow = !this.isShowCanalFactura
          this.isShowCanalFacturaAction(isShow)
          break
        case 'id':
          isShow = !this.isShowIdDatabaseFactura
          this.isShowIdDatabaseFacturaAction(isShow)
          break
        case 'accountingDate':
          isShow = !this.isShowAccountingDate
          this.isShowAccountingDateAction(isShow)
          break
        case 'paymentMethod':
          isShow = !this.isShowPaymentMethod
          this.isShowPaymentMethodAction(isShow)
          break
        case 'paymentDate':
          isShow = !this.isShowPaymentDate
          this.isShowPaymentDateAction(isShow)
          break
        case 'sent':
          isShow = !this.isShowSentInEmittedSearch
          this.isShowSentInEmittedSearchAction(isShow)
          break
        default:
          break
      }
      this.$forceUpdate()
    },
    handleVisibleChange () {
      this.chargeFilters()
    },
    chargeFilters () {
      if (this.canViewDistributionCentres) {
        this.columns = [
          {
            text: this.$t('invoices.tooltip.sent'), value: 'sent', show: this.isShowSentInEmittedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.seller'), value: 'vendedor', show: this.isShowVendedorFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.seller_centre'), value: 'centro-vendedor', show: this.isShowCentroVendedorFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.buyer'), value: 'comprador', show: this.isShowCompradorFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.buyer_generic_centre'), value: 'centro', show: this.isShowCentroGenericCompradorFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.buyer_centre'), value: 'centro-comprador', show: this.isShowCentroCompradorFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.buyer_delivery_centre'), value: 'centro-entrega', show: this.isShowCentroEntregaCompradorFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.buyer_invoicee_centre'), value: 'centro-facturado', show: this.isShowCentroFacturadoCompradorFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.series_code'), value: 'numero-serie', show: this.isShowNumSerieFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.invoice_number'), value: 'numero', show: this.isShowNumeroFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.issue_date'), value: 'emision', show: this.isShowEmisionFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.creation_date'), value: 'fecha-registro', show: this.isShowFechaRegistroFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.invoice_class'), value: 'clase-factura', show: this.isShowClaseFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.amount'), value: 'importe', show: this.isShowImporteFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.status'), value: 'estado', show: this.isShowEstadoFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.communication_method'), value: 'envio', show: this.isShowEnvioFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.currency'), value: 'divisa', show: this.isShowDivisaFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.register_number'), value: 'numero-registro', show: this.isShowNumRegistroFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.cancellation'), value: 'anulacion', show: this.isShowAnulacionFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.project'), value: 'servicio', show: this.isShowServicioFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.thirdParty'), value: 'tercero', show: this.isShowTerceroInEmittedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.channel'), value: 'canal', show: this.isShowCanalFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.id_invoice'), value: 'id', show: this.isShowIdDatabaseFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.paymentMethod'), value: 'paymentMethod', show: this.isShowPaymentMethod
          }, {
            text: this.$t('invoices.invoices_entity_table.accountingDate'), value: 'accountingDate', show: this.isShowAccountingDate
          }, {
            text: this.$t('invoices.invoices_entity_table.paymentDate'), value: 'paymentDate', show: this.isShowPaymentDate
          }
        ]
      } else {
        this.columns = [
          {
            text: this.$t('invoices.tooltip.sent'), value: 'sent', show: this.isShowSentInEmittedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.seller'), value: 'vendedor', show: this.isShowVendedorFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.seller_centre'), value: 'centro-vendedor', show: this.isShowCentroVendedorFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.buyer'), value: 'comprador', show: this.isShowCompradorFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.buyer_generic_centre'), value: 'centro', show: this.isShowCentroGenericCompradorFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.series_code'), value: 'numero-serie', show: this.isShowNumSerieFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.invoice_number'), value: 'numero', show: this.isShowNumeroFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.issue_date'), value: 'emision', show: this.isShowEmisionFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.creation_date'), value: 'fecha-registro', show: this.isShowFechaRegistroFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.invoice_class'), value: 'clase-factura', show: this.isShowClaseFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.amount'), value: 'importe', show: this.isShowImporteFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.status'), value: 'estado', show: this.isShowEstadoFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.communication_method'), value: 'envio', show: this.isShowEnvioFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.currency'), value: 'divisa', show: this.isShowDivisaFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.register_number'), value: 'numero-registro', show: this.isShowNumRegistroFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.cancellation'), value: 'anulacion', show: this.isShowAnulacionFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.project'), value: 'servicio', show: this.isShowServicioFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.thirdParty'), value: 'tercero', show: this.isShowTerceroInEmittedSearch
          }, {
            text: this.$t('invoices.invoices_entity_table.channel'), value: 'canal', show: this.isShowCanalFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.id_invoice'), value: 'id', show: this.isShowIdDatabaseFactura
          }, {
            text: this.$t('invoices.invoices_entity_table.paymentMethod'), value: 'paymentMethod', show: this.isShowPaymentMethod
          }, {
            text: this.$t('invoices.invoices_entity_table.accountingDate'), value: 'accountingDate', show: this.isShowAccountingDate
          }, {
            text: this.$t('invoices.invoices_entity_table.paymentDate'), value: 'paymentDate', show: this.isShowPaymentDate
          }
        ]
      }
      // Si el usuario sólo tiene un servicio, quitamos el checkbox de servicios
      if (this.optionsFilterService.length < 2) {
        for (let index = 0; index < this.columns.length; index++) {
          const element = this.columns[index]
          if (element.value === 'servicio') {
            this.columns.splice(index, 1)
          }
        }
      }
      // Si el usuario no puede anular facturas quitamos el check de anulación
      if (!this.canCancelInvoice) {
        for (let index = 0; index < this.columns.length; index++) {
          const element = this.columns[index]
          if (element.value === 'anulacion') {
            this.columns.splice(index, 1)
          }
        }
      }
    }
  },
  created () {
    this.chargeFilters()
  }
}
</script>

<style lang="scss" scoped>
.desplegable {
    top: 180px !important
}
.titulosetting {
      padding: 10px;
}
.titulosetting {
      padding: 10px;
}
</style>
